import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useField } from "formik";
import {
  AssetType,
  InterventionType,
  AssessmentMethodology,
  MappedDropDownOptions,
} from "../solution/types";

export type Options =
  | Array<AssetType>
  | Array<InterventionType>
  | Array<MappedDropDownOptions<AssessmentMethodology>>;

export type FieldPath =
  | "solution-intervention-type"
  | "solution-assessment-methodology"
  | "programme-info.asset-type";

export type SingleSelectProps = {
  options: Options;
  name: string;
  label: string;
  fieldPath: FieldPath;
};

type SelectValue = AssetType | InterventionType | AssessmentMethodology | "";

const getMappedValues = (
  option: SelectValue | MappedDropDownOptions<AssessmentMethodology>,
) => {
  if (typeof option === "string") return { value: option, label: option };
  return option;
};

function SingleSelect({ options, name, label, fieldPath }: SingleSelectProps) {
  const [field, meta, helpers] = useField<SelectValue>(fieldPath);
  const hasError = meta.touched && Boolean(meta.error);

  const handleChange = (event: SelectChangeEvent<SelectValue>) => {
    helpers.setValue(event.target.value);
  };

  return (
    <FormControl fullWidth variant="standard" error={hasError}>
      <InputLabel variant="standard" id={`solution-${name}-label`}>
        {label}
      </InputLabel>
      <Select
        variant="standard"
        labelId={`solution-${name}-label`}
        id={`solution-${name}`}
        name={fieldPath}
        label={label}
        value={field.value ?? ""}
        onChange={handleChange}
      >
        {options.map((option) => {
          const optionsMapped = getMappedValues(option);
          return (
            <MenuItem key={optionsMapped.value} value={optionsMapped.value}>
              {optionsMapped.label}
            </MenuItem>
          );
        })}
      </Select>
      {hasError && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
}

export default SingleSelect;
